// extracted by mini-css-extract-plugin
module.exports = {"button":"_810ca60","desktop":"_f2bffbc","single":"_5fae92d","sm":"_f1e7519","multi":"_0b17347"};